import { fetchPublishedArticles } from './articlesPublicApi';
import { prefetchPublicContent } from './publicContentCache';
import {
  ARTICLE_PREFETCH_PATHS,
  LIST_PREFETCH_PATHS,
} from './prefetchSiteContentPaths';

/** Warm public content caches immediately on app boot. */
export function prefetchSiteContent(): void {
  for (const path of LIST_PREFETCH_PATHS) {
    fetchPublishedArticles(path).catch(() => {
      // Background prefetch — errors are logged in fetchPublishedArticles.
    });
  }

  for (const path of ARTICLE_PREFETCH_PATHS) {
    prefetchPublicContent(path);
  }
}
